import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchCouponTableColumns,
  fetchAllCoupons,
  addCoupon,
  updateCoupon,
  deleteCoupon,
  activateDeactivateCoupon,
  fetchCouponById
} from "./thunk";

const initialState = {
  coupons: [],
  selectedCoupon: {
    ID: null,
    Code: "",
    Description: "",
    DiscountType: "PERCENT",
    DiscountValue: 0,
    MaxDiscountAmount: "",
    ValidFrom: "",
    ValidTo: "",
    IsFirstTimeOnly: false,
    IsStudentOnly: false,
    MaxTotalUsage: "",
    MaxUsagePerUser: 1,
    PlanIDs: [],
  },
  tableColumnNames: [],
  loading: false,
  error: null,
};

const CouponSlice = createSlice({
  name: "Coupons",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchCouponTableColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchCouponTableColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchCouponTableColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchAllCoupons.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchAllCoupons.fulfilled, (state, action) => {
        state.loading = false;
        state.coupons = action.payload;
    })
    .addCase(fetchAllCoupons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchCouponById.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchCouponById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCoupon = action.payload;
    })
    .addCase(fetchCouponById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addCoupon.pending, (state) => {
        state.error = null;
    })
    .addCase(addCoupon.fulfilled, (state, action) => {
        state.coupons.unshift(action.payload);
    })
    .addCase(addCoupon.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateCoupon.pending, (state) => {
        state.error = null;
    })
    .addCase(updateCoupon.fulfilled, (state, action) => {
        const index = state.coupons.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.coupons[index] = action.payload;
        }
    })
    .addCase(updateCoupon.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteCoupon.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteCoupon.fulfilled, (state, action) => {
        state.coupons = state.coupons.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteCoupon.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateCoupon.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateCoupon.fulfilled, (state, action) => {
        const index = state.coupons.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.coupons[index] = {...state.coupons[index], IsActive: action.payload.IsActive};
        }
    })
    .addCase(activateDeactivateCoupon.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default CouponSlice.reducer;
